<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar"/>
      <section class="qi-content">
        <header>
          <h1>Transferências - Resumo para Conferência</h1>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <vs-row v-if="!proccessExecuted">
          <vs-table
            class="pd-table"
            :data="resume"
          >
            <template slot="thead">
              <th>Disciplina</th>
              <th>Período</th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :data="discipline"
                v-for="(discipline, index) in data"
                :key="index"
                :class="discipline.CLASSE"
              >
                <vs-td>{{ discipline.DISCIPLINA }}</vs-td>
                <vs-td>{{ discipline.DTINICIAL }} a {{ discipline.DTFINAL }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-row>
        <vs-row v-if="!proccessExecuted" vs-w="12">
          <vs-col vs-w="6" vs-xs="12">
            <vs-button
              icon="refresh"
              @click="goBack()"
              type="filled"
            >
              Reorganizar Disciplinas
            </vs-button>
          </vs-col>
          <vs-col vs-w="6" vs-xs="12">
            <vs-button
              icon="check_circle"
              @click="executeTransfer()"
              color="#139B0E"
              type="filled"
            >
              Confirmar Transferência
            </vs-button>
          </vs-col>
        </vs-row>
        <vs-row v-if="proccessExecuted">
          <vs-alert
            color="success"
            :active.sync="proccessExecuted"
            close-icon="close"
            title="Processo de Transferência"
          >
            Transferência Realizada com sucesso!
          </vs-alert>
        </vs-row>
        <vs-row v-if="error">
          <vs-alert
            color="danger"
            :active.sync="error"
            close-icon="close"
            title="Processo de Transferência"
          >
            {{ error }}
          </vs-alert>
        </vs-row>
      </section>
    </div>
  </div>
</template>

<script>
import AcademicMovement from "../services/academicMovements";
//import moment from "moment";
import {
  clearStepsInformation,
  formatDateToLocale,
  getStepsInformation,
} from "../helpers";

export default {
  name: "TransfersResume",
  data: () => ({
    disciplines: [],
    courseTransfer: null,
    resume: [],
    proccessExecuted: false,
    error: null,
  }),
  created() {
    const { courseTransfer, disciplines } = getStepsInformation();
    this.courseTransfer = courseTransfer;
    this.disciplines = disciplines;

    this.resume = this.disciplines.map((discipline) => ({
      DISCIPLINA: discipline.DISCIPLINA,
      DATAORDEM: discipline.destinationSelected
        ? discipline.destinationSelected.DTINICIAL
        : discipline.DATAORDEM,
      DTINICIAL: discipline.destinationSelected
        ? formatDateToLocale(discipline.destinationSelected.DTINICIAL)
        : discipline.DTINICIAL,
      DTFINAL: discipline.destinationSelected
        ? formatDateToLocale(discipline.destinationSelected.DTFINAL)
        : discipline.DTFINAL,
      CLASSE: discipline.destinationSelected ? "destaque" : null,
    }));
    this.resume.sort(function (date1, date2) {
      let a = new Date(date1.DATAORDEM);
      let b = new Date(date2.DATAORDEM);
      if (a > b) return 1;
      if (a < b) return -1;
      return 0;
    });
  },
  methods: {
    goBack() {
      this.$router.push("/transfersStep2");
    },
    async executeTransfer() {
      this.$vs.loading({
        color: "danger",
      });
      const stepsData = getStepsInformation();
      let movementReasonSelected = stepsData.movementReasonSelected;
      let payload = {
        colligateId: this.courseTransfer.CODCOLIGADA,
        originQualificationId: this.courseTransfer.IDHABILITACAOFILIAL,
        destinyQualiticationId: this.courseTransfer.IDHABILITACAOFILIAL,
        ra: this.courseTransfer.RA,
        reasonId: movementReasonSelected,
        sameBranchAndShift: 1,
        originSchoolYearId: this.courseTransfer.IDPERLET,
      };

      let disciplinesToTransfer = [];
      this.disciplines.forEach((discipline) => {
        if (discipline.destinationSelected) {
          disciplinesToTransfer.push({
            originSubjectId: discipline.IDTURMADISC,
            destinySubjectId: discipline.destinationSelected.IDTURMADISC,
          });
        }
      });

      payload.disciplines = disciplinesToTransfer;

      await new AcademicMovement()
        .executeTransferProcess(payload)
        .then((result) => {
          if (result.status == "200") {
            this.proccessExecuted = true;
            clearStepsInformation();
          }
        })
        .catch((error) => {
          this.error = { error: error.response.data.error };
        })
        .finally(() => {
          this.$vs.loading.close();
        });

      //chama relatorio de atestado de matricula
    },
  },
};
</script>
<style scoped>
.destaque {
  color: darkred;
  background-color: #ddd;
}
</style>

